export enum InsurerDataRequester {
  BaselineComparison = 'baseline_comparison',
  CompareBatch = 'compare_batch',
}

export type ConnectionLogEntry = {
  id: string;
  correlationId: string;
  code: string;
  message: string;
  logLevel: number;
  logLevelName: string;
  solution: string | null;
  wiki: string | null;
  extraData: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
};

export type SearchConnectionLogsParams = {
  connectionId: string | undefined;
  requester: InsurerDataRequester;
  correlationId: string | null | undefined;
  page: number | null;
  pageSize: number | null;
};

export type SearchConnectionLogsResponse = {
  page: number | null;
  pageSize: number | null;
  totalItems: number;
  items: ConnectionLogEntry[];
};
